import React, { Fragment } from 'react';
import { Icon, ICON_NAMES } from "../../../elements/Icon";
import { GridColumn } from "../../../layout/GridColumn";
import { Divider } from "../../../elements/Divider";
import { getLabelAndValueString } from "./getLabelAndValueString";
export var getCheckInAndCheckOutMarkup = function getCheckInAndCheckOutMarkup(checkInTimeLabel, checkInTime, checkOutTimeLabel, checkOutTime) {
  return (!!checkInTime || !!checkOutTime) && React.createElement(GridColumn, {
    computer: 9,
    tablet: 7
  }, !!checkInTime && React.createElement(Fragment, null, React.createElement(Icon, {
    labelText: getLabelAndValueString(checkInTimeLabel, checkInTime),
    name: ICON_NAMES.CHECK_IN
  }), React.createElement(Divider, null)), !!checkOutTime && React.createElement(Icon, {
    labelText: getLabelAndValueString(checkOutTimeLabel, checkOutTime),
    name: ICON_NAMES.CHECK_OUT
  }));
};